module.exports = "http://cdn.realive.com.ua/src/views/donate/main/elements/shop/img/p_3.svg";